@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <div class="row">
      <div class='col-md-6'>
        <app-label label='Wniosek składany do:'>
          {{ applicationSubmittedTo }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Sposób odbioru:'>
          {{ application?.documentReceiptMethod?.name || '-' }}
        </app-label>
      </div>
      @if (application?.ePuapAddress; as ePuapAddress) {
        <div class='col-md-6'>
          <app-label label='Adres skrzynki E-puap:'>
            {{ ePuapAddress }}
          </app-label>
        </div>
      }
      @if (application?.eDeliveryAddress; as eDeliveryAddress) {
        <div class='col-md-6'>
          <app-label label='Adres skrzynki E-doręczeń:'>
            {{ eDeliveryAddress }}
          </app-label>
        </div>
      }
      <div class="col-md-6">
        <app-label label="Wniosek składany przez gminę:">
          {{ application?.applicationSubject || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Geometria:">
          {{ application?.geometry ? 'Tak' : 'Nie' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Znak sprawy gminy:">
          {{ application?.objectName || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Przedmiot inwestycji:">
          {{ application?.investmentName || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Inwestor
    </h3>
    <app-contractor-data-preview [expanded]="expanded" [application]="application">
    </app-contractor-data-preview>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
